import {Field} from 'redux-form'
import styles from './ItemVariantField.css'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import { OverlayTrigger, Popover } from 'react-bootstrap'

const popoverFocus = ({content}) => (
  <Popover id='purchaseOrder'>
    {content}
  </Popover>
)

class ItemVariantField extends React.Component {
  render () {
    const {member, showDelete, isRecipe} = this.props
    return (<div className='mk-grouped-input'>
      <div className='form-group col-sm-4'>
        <Field
          name={`${member}.name`}
          component={SettingField}
          className='form-control'
          placeholder='Name'
        />
      </div>
      <div className='form-group col-sm-4'>
        <Field
          name={`${member}.price`}
          component={SettingField}
          inputClassName='text-right'
          positiveNumberOnly
          placeholder='Rp. 0'
        />
      </div>
      <div className={`form-group col-sm-4`}>
        <Field
          name={`${member}.sku`}
          component={SettingField}
          className={`form-control ${styles['text-align-last-right']}`}
          placeholder='SKU'
          feedbackClassName={`${styles['feedback']}`}
          inputClassName={`${styles['last-input']}`}
        />
        {showDelete && !isRecipe && <div className={`${styles['btn-delete-wrapper']}`}>
          <span className={`${styles['btn-delete']}`}
            onClick={this._onDelete}
            type='button'>
            <i className='fa fa-times-circle' />
          </span>
        </div>}
        {isRecipe && <OverlayTrigger placement='top' overlay={popoverFocus({content: 'The item variant cannot be deleted because it has been associated with a Recipe. Please first delete the Recipe and try again.'})}>
          <div className={`${styles['btn-delete-wrapper']}`}>
            <span className={`${styles['btn-warning']}`} type='button'>
              <i className='fa fa-exclamation-circle' />
            </span>
          </div>
        </OverlayTrigger>}
      </div>
    </div>)
  }

  _onDelete = () => {
    this.props.onDelete()
  }
}

ItemVariantField.propTypes = {
  member: React.PropTypes.object,
  onDelete: React.PropTypes.func
}

export default ItemVariantField



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/ItemVariantModal/ItemVariantFieldArray/ItemVariantField/ItemVariantField.js